import '~/js/modules/stickyNav';
import ResortSpecialOffers from '~/js/components/resorts/ResortSpecialOffers';
import dataLayerProvider from '~/js/modules/resorts/datalayer-provider';

const { dataLayer = {} } = window.beaches_app.page;

dataLayerProvider.inject(dataLayer);


const specialOffers = document.querySelector('#resort-special-offers');
const offerList = [...beaches_app.page.offers];

ReactDOM.render(<ResortSpecialOffers offerList={offerList} cdnURL={beaches_app.page.cdnURL} />, specialOffers);
